import AlertesCriteresService from "@services/alertes-criteres-service";
import { initialiseComponents } from "../../core";
import { deprecatedGetAccountData } from "../account/account-data/account-data";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";
import AlertesHome from "./alertes-home";


export default class AlertesCriteres extends Component {
  private service: AlertesCriteresService;
  private data: any;
  private alertname: string;
  constructor(private props: unknown, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.injectTemplate();

    const button = this.element.querySelector("span.asSubmit");
    PubSub.subscribe("alertes-home.loaded", (msg:string, instance: AlertesHome) => {
      this.populate(instance);
      if (button) {
        this.service = new AlertesCriteresService("Alerte/Modification");
        button.addEventListener("click", () => {
          this.createAlert(instance);
        });
      }
    });
  }
  populate(alerte: AlertesHome): void {
    if (alerte.data) {
      if (alerte.data.trackingsClick && alerte.data.trackingsClick.length) {
        const submitButton = this.element.querySelector(".asSubmit");
        submitButton.setAttribute(
          "data-track",
          JSON.stringify(alerte.data.trackingsClick[0])
        );
      }
      if (alerte.data.trackingsLoad && alerte.data.trackingsLoad.length) {
        const form = this.element.querySelector("form");
        const eventanalytics = alerte.data.trackingsLoad[0];
        eventanalytics.trigger = "init";
        form.setAttribute("data-track", JSON.stringify(eventanalytics));
      }

      const details = this.element.querySelector("div");
      if (alerte.data.cities.length > 0 && alerte.data.cities[0].title) {
        details
          .querySelector("span:first-of-type")
          .append(alerte.data.cities[0].title);
      } else {
        details.querySelector("span:first-of-type").remove();
      }
      if (alerte.data.functions.length > 0 && alerte.data.functions[0].title) {
        details
          .querySelector("span:last-of-type")
          .append(alerte.data.functions[0].title);
      } else {
        details.querySelector("span:last-of-type").remove();
      }

      if (alerte.data.contracts.length > 0 && alerte.data.contracts[0].title) {
        const span: HTMLSpanElement = document.createElement("span");
        span.innerText = alerte.data.contracts[0].title;
        details.appendChild(span);
      }

      const lazyElement = document.querySelector("[data-alerte-home]");
      if (lazyElement.className.indexOf("global-lazy-loading") >= 0) {
        // Wait for the other lazy components before displaying the results
        lazyElement.addEventListener("display", () => {
          this.displayResults();
        });
        lazyElement.dispatchEvent(new CustomEvent("ready"));
      } else {
        // Just display the results
        this.displayResults();
      }

      initialiseComponents();
    }
  }
  displayResults(): void {
    document
      .querySelector("div[data-alerte-home]>div.lazy")
      .classList.add("hide");
    document
      .querySelector("div[data-alerte-home]>div.hide:not(.lazy)")
      .classList.remove("hide");
    document
      .querySelector("section.alertes .header.lazy-loading")
      .classList.remove("lazy-loading");
  }
  createAlert(alerte: AlertesHome): void { 
    this.alertname = alerte.data.alertName
    const data = {
      NomAlerte: this.alertname,
      Email: deprecatedGetAccountData().Email,
      Villes: alerte.data.cities[0].uri,
      ListeFonctions: alerte.data.functions[0].uri,
      TypesContratRecherche: alerte.data.contracts[0].uri,
      MotCle: alerte.data.functions[0].title,
      Frequence: "2",
      HiddenGuid: "",
    };

    this.service.setErrorHandler((error:any)=> {
      this.data = error;
    });
    this.service.post(data, this.handleResponse.bind(this))
  }
  handleResponse(response:any):void {
    this.element.innerHTML = "";
    const divSvg = document.createElement("div");
    divSvg.setAttribute("class", "valideAlerte");
    const svgns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgns, "svg");
    svg.setAttribute(
      "data-load-url",
      hw.getBaseRessourcesUrl() + "/img/svg/check.svg"
    );
    divSvg.appendChild(svg);
    this.element.appendChild(divSvg);
    const span = document.createElement("span");
    span.append("Votre alerte a été créée");
    this.element.appendChild(span);
    const spanCrit = document.createElement("span");
    spanCrit.innerText = `"${this.alertname}"`;
    this.element.appendChild(spanCrit);
    initialiseComponents();        
  }
}
